/** Debounce delay in ms before firing a Vimeo search request. */
export const DEBOUNCE_MS = 500;

/** Minimum query length before search is triggered. */
export const MIN_QUERY_LEN = 3;

/** Maximum Vimeo API requests allowed per rate-limit window. */
export const RATE_LIMIT_MAX = 15;

/** Rate-limit sliding window duration in milliseconds (1 minute). */
export const RATE_LIMIT_WINDOW_MS = 60_000;
